import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import LoadingPage from '../../../common/components/LoadingPage';
import { GET_COURSE, CourseGraphQL } from '../../../api/content';
import CourseDetail from '../../../common/components/CourseDetail';
import BackLink from '../../../common/components/BackLink';
import { useUser } from '../../../common/components/User';
import { useGraphqlQuery } from '../../../hooks/api';

export interface Props {
  courseId: string;
}

export default function CoursePage({ courseId }: Props) {
  const currentUser = useUser();
  const { isLoading, data: { courseById: course } = {} } = useGraphqlQuery<
    { courseById: CourseGraphQL },
    { id: string }
  >(
    { document: GET_COURSE, variables: { id: courseId } },
    {
      queryKey: ['course', 'detail', courseId],
      errorMessage: "We're having trouble loading this course at the moment.",
    },
  );

  if (isLoading || !course) return <LoadingPage />;

  return (
    <Grid item xl={8} lg={9} md={10} xs={12} style={{ margin: '1em' }}>
      <Box marginLeft={2} marginBottom={1}>
        <BackLink href={currentUser ? '/dashboard' : '/course'} />
      </Box>
      <CourseDetail course={course} />
    </Grid>
  );
}
